<template>
  <MainLayout>
    <v-layout style="padding: 1em" justify-center row fill-height>
      <v-flex>
        <v-card style="height: 100%" light color="#f4f4fa">
          <v-layout column style="height: 100%">
            <div
              style="width: 100%; height: calc(100% - 7px); border-radius: 8px"
              class="px-2 pt-2"
            >
              <iframe
                ref="iframe"
                src="https://tawang-3d-utility.dev.aetosky.com"
                frameborder="0 "
                style="width: 100%; height: 100%"
              />
            </div>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </MainLayout>
</template>

<script>
export default {
  metaInfo: {
    title: "MapView",
    meta: [{ name: "MapView", content: "MapView management" }],
  },
};
</script>

<style lang="css" scoped>
.form-item-view {
  display: flex;
  width: 100%;
  align-items: center;
}
.form-item-label {
  width: 10em;
  text-align: left;
  margin-right: 1.25em;
  /* margin-bottom: 1.25em; */
}
.header-contact {
  font-size: 1.25em;
  margin-bottom: 0.625em;
}
.full-height {
  flex: 1 1 auto;
  min-height: 0;
}
.scroll {
  overflow-y: auto;
}
</style>
